ResetModalInstanceCtrl.$inject = ["$window", "$uibModalInstance", "$state", "$localStorage", "Authentication"]; /**
                                                                                                                 * @desc Reset modal
                                                                                                                 * @example <gg-reset-modal></gg-reset-modal>
                                                                                                                 */
angular.
module('gplans.dashboard').
controller('ResetModalInstanceCtrl', ResetModalInstanceCtrl).
provider('ResetModal', function ResetModalProvider() {
  this.$get = ['$uibModal', '$rootScope', function ResetModalFactory($uibModal, $rootScope) {
    return new ResetModal($uibModal, $rootScope);
  }];
});

ResetModal.$inject = ['$uibModal', '$rootScope', '$localStorage', '$state'];

function ResetModal($uibModal, $rootScope) {
  return {
    init: init };


  var modalInstance, watchInitialized, resetModalShown;
  function init() {
    if (!watchInitialized) {
      watchInitialized = $rootScope.$watch('!pageIsLoading', function (current, previous, scope) {
        if (current && !resetModalShown) {
          resetModalShown = true;
          modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'templates/survey/gg-reset.modal.html',
            controller: 'ResetModalInstanceCtrl',
            controllerAs: 'vm' });

          modalInstance.result.then(function (res) {
            console.log(res);
            resetModalShown = false;
          }, function () {
            console.log('Cancelled');
            resetModalShown = false;
          })['finally'](function () {
            // reset watch in case ResetModal is not required anymore
            watchInitialized();
            watchInitialized = null;
          });
        }
      });
    }
  }
}

ResetModalInstanceCtrl.$inject = ['$window', '$uibModalInstance', '$state', '$localStorage', 'Authentication'];

function ResetModalInstanceCtrl($window, $uibModalInstance, $state, $localStorage, Authentication) {
  var vm = this;
  vm.cancel = cancel;
  vm.resetQuiz = resetQuiz;

  $uibModalInstance.result.then(function (res) {}, function () {
    $state.go('base.complete', { userSurvey: $localStorage['userSurvey'] });
  });

  function resetQuiz() {
    Authentication.resetAccount();

    $uibModalInstance.close('resetQuiz');
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }
}